const E = {
  "image/jpeg": "JPEG Image",
  "image/png": "PNG Image",
  "image/gif": "GIF Image",
  "image/webp": "WebP Image",
  "application/pdf": "PDF Document",
  "text/plain": "Plain Text",
  "text/markdown": "Markdown Document",
  "text/csv": "CSV File"
}, p = {
  MIN_SIZE: 1,
  // 1 byte
  MAX_SIZE: 10 * 1024 * 1024
  // 10 MB
}, c = {
  ".md": "text/markdown",
  ".pdf": "application/pdf",
  ".txt": "text/plain",
  ".csv": "text/csv"
}, g = /* @__PURE__ */ new Set(["application/vnd.ms-excel"]);
function u(t) {
  const a = t.name.includes(".") ? t.name.slice(t.name.lastIndexOf(".")).toLowerCase() : "";
  return (t.type === "" || t.type === "application/octet-stream" || g.has(t.type)) && a && a in c ? c[a] : t.type;
}
function F(t) {
  return t.size < p.MIN_SIZE ? "FILE_TOO_SMALL" : t.size > p.MAX_SIZE ? "FILE_TOO_LARGE" : u(t) in E ? null : "UNSUPPORTED_TYPE";
}
function f(t, a) {
  return a.some(
    (n) => n.name === t.name && n.size === t.size && n.file.lastModified === t.lastModified
  );
}
async function _(t, a, n) {
  const i = new FormData();
  return Object.entries(a.signature.fields).forEach(([r, s]) => {
    i.append(r, s);
  }), i.append("file", t), new Promise((r, s) => {
    const e = new XMLHttpRequest();
    n && e.upload.addEventListener("progress", (o) => {
      if (o.lengthComputable) {
        const d = o.loaded / o.total * 100;
        n(d);
      }
    }), e.addEventListener("load", () => {
      if (e.status >= 200 && e.status < 300) {
        const o = a.signature.fields.key, d = a.signature.url.endsWith("/") ? a.signature.url.slice(0, -1) : a.signature.url, l = o.startsWith("/") ? o : `/${o}`, m = `${d}${l}`;
        r(m);
      } else
        s(new Error(`Upload failed with status ${e.status}: ${e.responseText}`));
    }), e.addEventListener("error", () => {
      s(new Error("Network error during upload"));
    }), e.addEventListener("abort", () => {
      s(new Error("Upload was aborted"));
    }), e.open("POST", a.signature.url), e.send(i);
  });
}
function w(t, a) {
  const n = [], i = [], r = [], s = t.__uploadFiles.get();
  return a.forEach((e) => {
    if (f(e, s)) {
      r.push({ name: e.name, reason: "File already selected" });
      return;
    }
    const o = F(e);
    if (o) {
      let l = "";
      switch (o) {
        case "UNSUPPORTED_TYPE":
          l = `File type ${u(e) || e.type || "unknown"} is not supported`;
          break;
        case "FILE_TOO_LARGE":
          l = `File is too large (max ${p.MAX_SIZE / 1024 / 1024}MB)`;
          break;
        case "FILE_TOO_SMALL":
          l = "File is too small";
          break;
        case "FILE_CORRUPTED":
          l = "File appears to be corrupted";
          break;
      }
      i.push({ name: e.name, error: l });
      return;
    }
    const d = {
      id: crypto.randomUUID(),
      file: e,
      mimeType: u(e),
      size: e.size,
      name: e.name,
      status: "pending"
    };
    n.push(d);
  }), n.length > 0 && t.addUploadFiles(n), {
    addedCount: n.length,
    errors: i,
    skipped: r
  };
}
async function y(t, a) {
  await t.waitUntilReady();
  const i = t.__uploadFiles.get().find((r) => r.id === a);
  if (!i)
    throw new Error(`File with ID ${a} not found`);
  try {
    t.updateUploadFile(a, { status: "uploading", uploadProgress: 0 });
    const r = await t.getUploadSignature({
      size: i.size.toString(),
      mime_type: i.mimeType
    }), s = await _(i.file, r, (e) => {
      t.updateUploadFile(a, { uploadProgress: e });
    });
    return t.updateUploadFile(a, { status: "uploaded", uploadedUrl: s, uploadProgress: 100 }), s;
  } catch (r) {
    const s = r instanceof Error ? r.message : "Upload failed";
    throw t.updateUploadFile(a, { status: "error", error: s }), r;
  }
}
async function T(t) {
  const n = t.__uploadFiles.get().filter((e) => e.status === "pending");
  if (n.length === 0)
    return { successful: [], failed: [] };
  const i = await Promise.allSettled(
    n.map(async (e) => {
      try {
        const o = await y(t, e.id);
        return {
          id: e.id,
          name: e.name,
          mimeType: e.mimeType,
          uploadedUrl: o
        };
      } catch (o) {
        throw console.error(`Failed to upload file ${e.name}:`, o), o;
      }
    })
  ), r = [], s = [];
  return i.forEach((e, o) => {
    const d = n[o];
    if (e.status === "fulfilled")
      r.push(e.value);
    else {
      const l = e.reason instanceof Error ? e.reason.message : "Upload failed";
      s.push({
        id: d.id,
        name: d.name,
        error: l
      }), t.removeUploadFile(d.id);
    }
  }), { successful: r, failed: s };
}
export {
  p as FILE_SIZE_LIMITS,
  E as SUPPORTED_FILE_TYPES,
  w as addCopilotFiles,
  f as fileAlreadyExists,
  u as resolveFileMimeType,
  T as uploadAllCopilotFiles,
  y as uploadCopilotFile,
  _ as uploadToGCS,
  F as validateFile
};
